import { DeleteOutline, Info } from "@mui/icons-material";
import { InputBase, Stack, Tooltip, Typography } from "@mui/material";
import { GridActionsCellItem, GridColDef, GridRenderCellParams } from "@mui/x-data-grid-premium";
import { HighlightSelectBox } from "../../../components";
import { SelectBoxOption } from "../../../interfaces";

export const BOMCostingTypes = [
    { value: "Per-Hour", label: "Per Hour" },
    { value: "Per-Day", label: "Per Day" },
    { value: "Per-Month", label: "Per Month" },
    { value: "fixed", label: "Fixed" },
]

export const AssemblyProcessColumn = (onChange: any, handleDeleteClick: any, isViewOnly: boolean = true, currency: string, hasNewTotalCost?: boolean): GridColDef[] => {
    let columns: GridColDef[] = [
        { field: 'sl_no', headerName: 'Sl No', disableColumnMenu: true, sortable: false },
        {
            field: 'process_name', width: 250, disableColumnMenu: true, sortable: false, headerName: 'Overhead/Activity cost', renderCell: (params: GridRenderCellParams) => {
                return <InputBase
                    id="assembly-name"
                    placeholder="Enter Overhead/Activity cost"
                    type="text"
                    readOnly={isViewOnly}
                    value={params.row.process_name}
                    onChange={(e) => onChange(params.row.sl_no, 'process_name', e.target.value)}
                    onKeyDown={(event) => {
                        event.stopPropagation();
                    }}
                />
            }
        },
        {
            field: "units",
            width: 200,
            headerName: "UoM",
            valueGetter: (value, row, column, apiRef) => row?.units,
            renderCell: (params: GridRenderCellParams) => {
                return <HighlightSelectBox
                    id={`assm_process_uom_${params.id}`}
                    required
                    disableClearable
                    label={""}
                    margin={"none"}
                    viewOnly={isViewOnly}
                    fullWdith
                    value={params.row.units}
                    options={BOMCostingTypes}
                    onChange={(data: SelectBoxOption) => {
                        onChange(params.row.sl_no, 'units', data)
                    }}
                />
            }
        },
        {
            field: 'cost', headerName: 'Cost', disableColumnMenu: true, sortable: false, renderCell: (params: GridRenderCellParams) => {
                return isViewOnly ? params.row.cost : <InputBase readOnly={isViewOnly} id="assembly-cost" placeholder="Enter Cost" type="number" value={params.row.cost} onChange={(e) => onChange(params.row.sl_no, 'cost', e.target.value)} />
            },
            type: isViewOnly ? "number" : "string",
            align: isViewOnly ? "right" : 'left',
        },
        {
            field: 'currency', headerName: 'Currency', width: 200, disableColumnMenu: true, sortable: false, valueGetter: (value, row, column, apiRef) => {
                return currency
            },
        },
        {
            field: 'qty', headerName: 'Qty', disableColumnMenu: true, sortable: false, renderCell: (params: GridRenderCellParams) => {
                return isViewOnly ? params.row.qty : <InputBase readOnly={isViewOnly} id="assembly-qty" placeholder="Enter Qty" type="number" value={params.row.qty} onChange={(e) => onChange(params.row.sl_no, 'qty', e.target.value)} />
            },
            type: isViewOnly ? "number" : "string",
            align: isViewOnly ? "right" : 'left',
        },
        {
            field: 'total_cost', headerName: 'Total Cost (Currency)', width: 200, disableColumnMenu: true, sortable: false, valueGetter: (value, row, column, apiRef) => {
                return `${row?.total_cost ?? ""} ${currency}`
            },
            type: "number",
            align: 'right',
        },
        {
            field: 'actions',
            type: 'actions',
            headerName: 'Delete',
            width: 100,
            cellClassName: 'actions',
            getActions: ({ id, row }) => {
                return [
                    <GridActionsCellItem
                        disabled={isViewOnly}
                        icon={<DeleteOutline />}
                        label="Delete"
                        onClick={() => handleDeleteClick(row.sl_no, row._id, row.process_name)}
                        color="inherit"
                    />,
                ];
            },
        },
    ];

    if (hasNewTotalCost) {
        columns = [...columns.slice(0, 7), {
            field: 'new_total_cost',
            width: 200,
            type: "number",
            align: 'right',
            disableColumnMenu: true,
            sortable: false,
            renderHeader: (params) => {
                return (
                    <Tooltip arrow title="Calculated based on provided custom cost" placement="top">
                        <Stack
                            direction={"row"}
                            sx={{
                                gap: 1,
                                alignItems: "center"
                            }}>
                            <Info color="primary" fontSize='small' />
                            <Typography variant="body2" ><b>New Total Cost</b></Typography>
                        </Stack>
                    </Tooltip>
                );
            },
            valueGetter: (value, row, column, apiRef) => {
                return row?.new_total_cost ?? ""
            }
        },]
    }

    return columns;
};